const isMobile = (): boolean => window.innerWidth < 480

export default isMobile
